/* NgRx */
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ClientsListState} from './clients-list.reducer';

// Selector functions
const clientsListData =
  createFeatureSelector<ClientsListState>('ss-cord.clients-list');


// Get Clients List
export const clientsList = createSelector(
  clientsListData,
  (state: ClientsListState) => state.clientsList
);

export const dashboardFilter = createSelector(
  clientsListData,
  (state: ClientsListState) => state.dashboardFilter
);
export const clinicFilter = createSelector(
  clientsListData,
  (state: ClientsListState) => state.clinicFilter
);

export const statusFilter = createSelector(
  clientsListData,
  (state: ClientsListState) => state.statusFilter
);

export const groupTypeFilter = createSelector(
  clientsListData,
  (state: ClientsListState) => state.groupTypeFilter
);

export const clinicsList = createSelector(
  clientsListData,
  (state: ClientsListState) => state.clinicsList
);

export const groupsList = createSelector(
  clientsListData,
  (state: ClientsListState) => state.groupsList
);

export const participantsAndCaregiversList = createSelector(
  clientsListData,
  (state: ClientsListState) => state.participantsAndCaregiversList
);

export const participantsWeightList = createSelector(
  clientsListData,
  (state: ClientsListState) => state.participantsWeightList
);

export const participantsBehaviourList = createSelector(
  clientsListData,
  (state: ClientsListState) => state.participantsBehaviourList
);

export const metricOptionList = createSelector(
  clientsListData,
  (state: ClientsListState) => state.measurementInformationList
);

export const measurementFilter = createSelector(
  clientsListData,
  (state: ClientsListState) => state.measurementFilter
);

export const configId = createSelector(
  clientsListData,
  (state: ClientsListState) => state.configId
);

export const orgTypeListFilter = createSelector(
  clientsListData,
  (state: ClientsListState) => state.orgTypeListFilter
);

export const clinicStatusListFilter = createSelector(
  clientsListData,
  (state: ClientsListState) => state.clinicStatusListFilter
);

export const groupListFilter = createSelector(
  clientsListData,
  (state: ClientsListState) => state.groupListFilter
);

export const userStatusListFilter = createSelector(
  clientsListData,
  (state: ClientsListState) => state.userStatusListFilter
);
